import { render, staticRenderFns } from "./orderListItems.vue?vue&type=template&id=43900f70&"
import script from "./orderListItems.vue?vue&type=script&lang=js&"
export * from "./orderListItems.vue?vue&type=script&lang=js&"
import style0 from "./orderListItems.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports